






















import Vue from "vue";
import { LocaleService } from "@/services/locale.service";
import { setApiServiceLocale } from "@/services/api.service";
import { Component } from "vue-property-decorator";

@Component
export default class LanguageChanger extends Vue {
  languagesList: any[] = [
    {
      text: "KZ",
      value: "kk",
    },
    {
      text: "RU",
      value: "ru",
    },
  ];

  get languages() {
    return this.languagesList.filter(lang => lang.value !== this.$i18n.locale);
  }

  get currentLanguage() {
    return this.languagesList.find(lang => lang.value === this.$i18n.locale)
      .text;
  }

  changeLocale(locale: string) {
    if (locale === this.$i18n.locale) return;
    this.$i18n.locale = locale;
    LocaleService.setLocale(locale);
    setApiServiceLocale();
  }
}
